import { render } from "./tw-ws-countTo.vue?vue&type=template&id=b3079fd0"
import script from "./tw-ws-countTo.vue?vue&type=script&lang=js"
export * from "./tw-ws-countTo.vue?vue&type=script&lang=js"
script.render = render

export default script